import React from 'react';
const TotalAmountsTable = ({ data, isBo = false }) => {
    const containerClassName = isBo ? 'totalAmountsTable' : 'FO__totalAmountsTable';
    return (React.createElement("div", { className: containerClassName }, data.map((item, index) => (isBo && (Number(item.value.replace(/\s/g, "").replace("€", "").replace(",", ".")) || 0) > 0 &&
        React.createElement("div", { key: index },
            React.createElement("div", null,
                React.createElement("div", { className: "totalAmountsTable__value" }, item.value),
                React.createElement("div", { className: "totalAmountsTable__label" }, item.label)))))));
};
export default TotalAmountsTable;
